import {AccountInformation} from "components/non-employee/employee-add/AccountInformation"
import {useEffect, useMemo, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {setPersonalDetail} from "reducers/addNonEmployeeReducer"
import {API_NON_EMPLOYEE} from "services/apiNonEmployee"
import {useFetch} from "services/useFetch"

export const AccountInformationContainer = ({errorForm}) => {
    const dispatch = useDispatch()
    const dataEmployee = useSelector((state) => state.addNonEmployeeReducer)
    const [selectedBank, setSelectedBank] = useState()
    const {data: dataListBank} = useFetch(API_NON_EMPLOYEE.LIST_BANK, {}, {isFetching: true})

    const optionsBank = useMemo(() => {
        if (dataListBank?.data?.length === 0) return []
        return dataListBank?.data?.map((bank) => ({
            label: bank.name,
            value: bank.code
        }))
    }, [dataListBank?.data])

    useEffect(() => {
        setSelectedBank({
            label: dataEmployee?.personal_detail?.bank_name,
            value: dataEmployee?.personal_detail?.bank_code,
        })
    }, [dataEmployee?.personal_detail?.bank_code])

    const onChangeForm = (e) => {
        const {name, value} = e
        if (name === 'bank_name') {
            setSelectedBank(value)
            dispatch(setPersonalDetail({
                name: name,
                value: value
            }))
            return
        }
        dispatch(setPersonalDetail(e))
    }

    const onValidateAccount = () => {
        // const params = {
        //     bank: selectedBank.value,
        //     account: dataEmployee?.personal_detail?.bank_account_number
        // }
        // validateBankAccount(params).then((response) => {
        //     dispatch(setPersonalDetail({name: 'bank_account_name', value: response.data.account_name}))
        // })
        //     .catch(err => {
        //         if(err.code === '503-A001'){
        //             dispatch(setPersonalDetail({name: 'bank_account_number', value: ''}))
        //         }
        //     })
    }

    const props = {
        canValidate: selectedBank?.value && dataEmployee?.personal_detail?.bank_account_number,
        optionsBank,
        selectedBank,
        form: dataEmployee,
        errorForm,
        onChangeForm,
        onValidateAccount,
    }

    return (
        <AccountInformation {...props} />
    )
}
